module.exports = __webpack_public_path__ + "img/foldericon.d2506aab.svg";